import { render, staticRenderFns } from "./loginGx.vue?vue&type=template&id=58857abf&scoped=true&"
import script from "./loginGx.vue?vue&type=script&lang=js&"
export * from "./loginGx.vue?vue&type=script&lang=js&"
import style0 from "./loginGx.vue?vue&type=style&index=0&id=58857abf&scoped=true&lang=css&"
import style1 from "./loginGx.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58857abf",
  null
  
)

export default component.exports